import { WebSourceAsset } from "../../../redux/assets-slice";
import { ServerType } from "../../../types/web-sources";
import { Viewer } from "../main";
import {
  WebSource,
  ArcGISMapServer,
  ArcGISImageServer,
  ArcGISFeatureServer,
  OGCWMS,
  OGCWFS,
  OGCWMTS,
  TileServer
} from ".";

export class WebSourceHandler {
  public viewer: Viewer;
  private sources: WebSource[] = [];

  constructor(viewer: Viewer) {
    this.viewer = viewer;
  }

  reconcile(webSources: WebSourceAsset[]) {
    const currentIDs = new Set(this.sources.map(x => x.id));
    const newAssetIDs = new Set(webSources.map(x => x.id));
    const sourcesToLoad = webSources.filter(x => !currentIDs.has(x.id));
    const sourcesToDelete = this.sources.filter(x => !newAssetIDs.has(x.id));

    // Delete sources that need to be removed
    sourcesToDelete.forEach(webSource => {
      this.deleteSource(webSource);
    });

    // Add new sources
    sourcesToLoad.forEach(asset => {
      this.addNewSource(asset);
    });

    // Toggle visibility for each source
    webSources.forEach(asset => {
      this.toggleVisibility(asset);
    });
  }

  getByID(assetID) {
    return this.sources.find(file => file.id === assetID);
  }

  toggleVisibility(asset: WebSourceAsset) {
    let source = this.getByID(asset.id);
    if (!source) return;

    source.toggleVisibility(asset);
  }

  getNewSource(asset: WebSourceAsset) {
    const {type} = asset.data;

    switch (type) {
    case ServerType.ArcGISMapServer:
      return new ArcGISMapServer(this, asset);
    case ServerType.ArcGISImageServer:
      return new ArcGISImageServer(this, asset);
    case ServerType.ArcGISFeatureServer:
      return new ArcGISFeatureServer(this, asset);
    case ServerType.OGCWMS:
      return new OGCWMS(this, asset);
    case ServerType.OGCWFS:
      return new OGCWFS(this, asset);
    case ServerType.OGCWMTS:
      return new OGCWMTS(this, asset);
    case ServerType.TileServer:
      return new TileServer(this, asset);
    default:
      return;
    }
  }

  addNewSource(asset: WebSourceAsset) {
    let newSource = this.getNewSource(asset);
    if (!newSource) return;

    this.sources.push(newSource);
  }

  deleteSource(webSource: WebSource) {
    webSource.destroy();

    const index = this.sources.indexOf(webSource);
    this.sources.splice(index, 1);
  }
}